import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../components/Input';
import Button from '../components/Button';
const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    identifier: '',
    password: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, you would validate and authenticate here
    navigate('/dashboard');
  };
  return <div className="min-h-screen w-full flex flex-col bg-gradient-to-br from-blue-50 to-white" data-id="element-293">
      {/* Modern gradient header */}
      <div className="h-48 bg-gradient-to-r from-blue-600 to-blue-400 rounded-b-[3rem] shadow-lg flex justify-center items-center relative overflow-hidden" data-id="element-294">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1557683316-973673baf926?auto=format&fit=crop&q=80')] opacity-10" data-id="element-295"></div>
        <div className="relative" data-id="element-296">
          <div className="text-4xl font-bold text-white mb-2" data-id="element-297">SimFin</div>
          <div className="text-blue-100 text-center" data-id="element-298">
            Portal de Gestión Financiera
          </div>
        </div>
      </div>
      {/* Login form */}
      <div className="flex-1 flex flex-col items-center px-6 -mt-8" data-id="element-299">
        <div className="w-full max-w-md bg-white rounded-3xl shadow-xl p-8" data-id="element-300">
          <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center" data-id="element-301">
            Iniciar Sesión
          </h2>
          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-302">
            <Input label="Número de documento o correo electrónico" placeholder="Ingrese su documento o correo" name="identifier" value={formData.identifier} onChange={handleChange} required data-id="element-303" />
            <Input label="Contraseña" type="password" placeholder="Ingrese su contraseña" name="password" value={formData.password} onChange={handleChange} required data-id="element-304" />
            <div className="flex justify-end" data-id="element-305">
              <button type="button" className="text-blue-600 text-sm hover:text-blue-700 transition-colors" data-id="element-306">
                Olvidé mi contraseña
              </button>
            </div>
            <Button type="submit" fullWidth data-id="element-307">
              Ingresar
            </Button>
          </form>
          <div className="mt-8 pt-6 border-t border-gray-100 text-center" data-id="element-308">
            <p className="text-sm text-gray-500" data-id="element-309">
              ¿Necesitas ayuda? Contacta a soporte
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default Login;